import { render, staticRenderFns } from "./PaymentRequestButton.vue?vue&type=template&id=624f69cf"
import script from "./PaymentRequestButton.vue?vue&type=script&lang=js"
export * from "./PaymentRequestButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PaymentRequestButton.vue"
export default component.exports